/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Update_ButtonInputs */



/**
* | output |
* | --- |
* | "Update Position" |
*
* @param {Position_Modal_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_update_button = /** @type {((inputs?: Position_Modal_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre a jour la position")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna posizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить позицию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar posición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置を更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति अद्यतन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar posição")
	return /** @type {LocalizedString} */ ("Update Position")
});